import { Injectable } from '@angular/core';
import { Observable, of, from, fromEvent } from 'rxjs';
import * as _ from 'lodash';

declare var abp: any;

@Injectable({
    providedIn: 'root'
})
export class TranslationsService {

    localizationSources: string[] = [];
 
    constructor() {
        _.each(abp.localization.sources, (source) => {
            this.localizationSources.unshift(source.name);
        });
    }
}
